import React from 'react';
import { MessageSquare } from 'lucide-react';

/**
 * CommentsToggle: Top_Bar button that opens and closes the Comments_Panel,
 * with the number of comments. The caller hides it when the comments feature
 * flag is off.
 *
 * Requirements: 12.1, 3.2.
 */
export interface CommentsToggleProps {
  count: number;
  open: boolean;
  onToggle?: () => void;
}

export const CommentsToggle: React.FC<CommentsToggleProps> = ({ count, open, onToggle }) => (
  <button
    type="button"
    aria-pressed={open}
    aria-label={`Comments, ${count} ${count === 1 ? 'comment' : 'comments'}`}
    onClick={onToggle}
    className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[13px] font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-[#834DFB] ${
      open
        ? 'border-[#834DFB] bg-[#F5F3FF] text-[#5A21C9]'
        : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'
    }`}
  >
    <MessageSquare size={15} strokeWidth={2} aria-hidden="true" />
    <span>Comments</span>
    <span
      data-testid="comments-count"
      className="rounded-full bg-[#1c1428] px-1.5 text-[11px] font-bold leading-[18px] text-[#F0E100]"
    >
      {count}
    </span>
  </button>
);

export default CommentsToggle;
